export default {
  all: 'Tutti',
  app_disabled: 'Stiamo aggiornando i contenuti, torneranno live a breve',
  autocomplete_placeholder: 'Inserisci indirizzo o CAP',
  back_to_list: 'Torna alla lista',
  catalogue_image: "Catalogue's image",
  catalogue_loading: 'Stiamo recuperando il tuo volantino',
  catalogues: 'Volantini',
  catalogues_in_area: 'Volantini in zona',
  catalogues_loading: 'Caricamento in corso',
  catalogues_near_you: 'Volantini nelle vicinanze',
  catalogues_not_found:
    'Non ci sono volantini al momento nelle vicinanze, prova ad inserire un altro indirizzo o torna presto per altre offerte',
  close_catalogues: 'Chiudi',
  close_products: 'Chiudi',
  close_stores: 'Chiudi',
  closed: 'Chiuso',
  characteristics: 'Caratteristiche',
  days_of_week: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
  description_missing: 'Nessuna descrizione disponibile',
  expires: 'Scade',
  expired: 'Scaduto',
  find_me: 'Trovami',
  geolocation_error: 'Attenzione: la localizzazione non è andata a buon fine',
  geolocation_image: 'Geolocalizzazione',
  geolocation_info:
    'Per mostrarti i volantini dei negozi più vicini a te, abbiamo bisogno di conoscere la tua posizione. Inserici il tuo indirizzo o CAP.',
  geolocation_loading: 'Stiamo impostando la tua posizione',
  geolocation_missing:
    'Aggiorna la tua posizione per avere le offerte e i punti vendita più vicini a te.',
  localize_yourself: 'Localizzati',
  more_info: 'Maggiori informazioni',
  next: 'Successivo',
  not_now: 'Non ora',
  of: 'Di',
  open: 'Aperto',
  open_24_hours: 'Aperto 24 ore',
  or: 'oppure',
  other_stores: 'Offerte disponibili anche qui:',
  page: 'Pagina',
  previous: 'Precedente',
  price: 'Prezzo',
  products: 'Prodotti',
  products_find: 'Cerca un prodotto',
  index: 'Indice',
  products_list: 'Lista prodotti',
  read_all: 'Leggi tutto',
  sale: 'Sconto',
  search_placeholder: 'Cosa stai cercando?',
  stores: 'Negozi',
  understand: 'Ho capito',
  usergeolocation_label:
    'Inserisci il tuo indirizzo per trovare le migliori offerte nei negozi nelle vicinanze',
  fullscreen: 'Schermo Intero',
  fullscreenExit: 'Riduci Schermo',
  no_nearest_store_at: 'Nessun negozio nelle vicinanze',
  nearest_store_at: 'Negozio più vicino a {distance}',
  nearby_stores: 'Negozi nelle vicinanze',
  show_all_pages: 'Vedi tutte le pagine',
  show: 'Mostra',
  directionVertical: 'Scroll verticale',
  directionHorizontal: 'Scroll orizzontale',
  share: 'Condividi',
  share_with_friends: 'Condividi con i tuoi amici',
  copy_link: 'Copia link',
  sms: 'SMS',
  email: 'email',
  more_stores: 'altri negozi',
  stores_within: 'Negozi entro {maxDistance}',
  invalid_offers_disclaimer:
    'Le offerte di questo volantino non sono valide nei punti vendita vicino a te, apri un altro volantino oppure localizzati in una zona diversa.',
  download_pdf: 'Download PDF',
  flyer_version_switch_pdf: 'Volantino PDF',
  flyer_version_switch_digital: 'Volantino Digitale',
  flyer_unavailable_error:
    'Impossibile aprire questo volantino. Controlla il link o riprova più tardi.',
  available_options: 'Disponibile in {numOptions} opzioni:',
};
